import React from 'react'
import NotificationAutoInterUpdator from '../../../../NotificationAutoInterUpdator'
import NotificationViewModel from '../../../../NotificationViewModel'
import i18next from 'i18next'

const NewSubDepManagmentAssignment = (props) => {
  const { notification, project } = props
  NotificationAutoInterUpdator(props)
  const lang = i18next.language
  const rtl = lang === 'ar'
  return (
    <NotificationViewModel
      {...props}
      learningSectionContent={''}
      notificationBody={
        <section style={{ width: '100%' }}>
          {rtl
            ? `لقد تم تعيينك مديرا لقسم فرعى جديد`
            : 'You have been assigned as manager for the new sub-department'}{' '}
          {notification?.accompaniedData?.subdepartment?.Name}{' '}
          {rtl ? 'فى' : 'in'}
          {project?.ProjectName}
        </section>
      }
      buttonsArray={[]}
    />
  )
}

export default NewSubDepManagmentAssignment
